import HttpClient from "../client/httpclient";
var isOpen = false
class SearchBar {
    constructor(DOMelement, searchbarOpenBtns) {
        try {
            this.el = DOMelement;
            this.closeButton = document.getElementById("sd-search-close");
            this.closeButtonDesktop = document.getElementById("sd-search-close-desktop");

            this.inputField = this.el.querySelector("#search");
            this.openButtons = searchbarOpenBtns;
            this.resultsData = "";
            this.method = "GET";
            this.url = document.getElementById("default-destination-url").getAttribute("data-action");
            const dropdownMenuItems = document.querySelectorAll(".sd-navigation-expand__dropdown");

            if (this.openButtons) {
                [...this.openButtons].forEach((button) =>
                    button.addEventListener("click", (event) => {
                        dropdownMenuItems.forEach(el => el.classList.remove("active"));
                        document.getElementsByTagName('html')[0].classList.remove('mobile-menu-active');

                        event.preventDefault();
                        if (!isOpen) {
                            this.open();
                            this.addResults();

                        }
                    })
                );
            }
            this.closeButton.addEventListener("click", (event) => {
                event.preventDefault();
                this.closePopup();
            });
            this.closeButtonDesktop.addEventListener("click", (event) => {
                event.preventDefault();
                this.closePopup();
            });
            this.outsidePopupclick = this.outsidePopupclick.bind(this);

        } catch (error) {
            console.log(error);
        }
    }


    addResults = async (event) => {
        this.resultsData = await HttpClient.AsyncGetRequest(this.url, this.method);
        this.resultsData = JSON.parse(this.resultsData);
        if (this.resultsData) {
            var defaultContents = document.getElementById("default-search-options");
            defaultContents.innerHTML = ""
            let defaultData = `
      <div class="sd-destination-items">
        <ul class="sd-country">
            <li class="sd-destinations-title">
                <p>${this.resultsData.destinationsTitle}</p>
            </li>`;
            for (let i = 0; i < this.resultsData.destinationList.length; i++) {
                defaultData += `
            <li class=" country-page"><a href="${this.resultsData.destinationList[i].Link}">${this.resultsData.destinationList[i].Title}</a></li>
            `;
            }
            defaultData += `
        </ul>
        <ul class="sd-area">
            <li class="sd-destinations-title">
                <p>${this.resultsData.offersTitle}</p>
            </li>`;
            for (let i = 0; i < this.resultsData.offerList.length; i++) {
                defaultData += `
            <li><a href="${this.resultsData.offerList[i].Link}">${this.resultsData.offerList[i].Title}</a></li>
            `;
            }
            defaultData += `
        </ul>
    </div>`;
            defaultContents.innerHTML = `${defaultData}`
        }
    }

    outsidePopupclick(e){
        if (isOpen && (!document.getElementById('searchbar-container').contains(e.target) && !document.getElementById('sd-search-open').contains(e.target) && !document.getElementById('sd-search-open-desktop').contains(e.target))) {
            this.closePopup();
        }
    }

    open() {
        isOpen = true;
        this.el.classList.add("opened");
        document.getElementsByTagName('html')[0].classList.remove('mobile-menu-active');
        document.querySelector(".sd-navigation-expand").classList.remove('displayMobile');
        document.querySelector("#sd-navigation-drawer__open-handle").checked = false
        document.querySelectorAll(".sd-navigation-expand__dropdown").forEach(el => el.classList.remove("active"));
        document.querySelectorAll(".sd-navigation-expand-content__dropdown").forEach(el => el.classList.remove("active-sub"));
        this.inputField.focus();
        document.getElementById("sd-search-open").style.display = 'none';
        document.getElementById("sd-search-open-desktop").style.display = 'none';
        document.getElementById("sd-search-close-desktop").style.display = 'flex';
        document.getElementById("sd-search-close").style.display = 'flex';

        window.addEventListener("click", this.outsidePopupclick);
    }

    closePopup() {
        window.removeEventListener("click", this.outsidePopupclick);
        isOpen = false;
        this.el.classList.remove("opened");
        this.inputField.value = "";
        document.getElementById("sd-search-open").style.display = 'flex';
        document.getElementById("sd-search-open-desktop").style.display = 'flex';
        document.getElementById("sd-search-close-desktop").style.display = 'none';
        document.getElementById("sd-search-close").style.display = 'none';
    }
}

export default SearchBar;